import { render, staticRenderFns } from "./loanDlog.vue?vue&type=template&id=c5aaa8aa&scoped=true"
import script from "./loanDlog.vue?vue&type=script&lang=js"
export * from "./loanDlog.vue?vue&type=script&lang=js"
import style0 from "./loanDlog.vue?vue&type=style&index=0&id=c5aaa8aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aaa8aa",
  null
  
)

export default component.exports